



















import { Component, Prop, Vue } from 'vue-property-decorator';
import LineCell from './lineCell/lineCell.vue';

import * as def from '@/definitions'

@Component({
  components: {
      LineCell
  },
})
export default class SelectLine extends Vue 
{
    private selectedIndex : number = 0;

    private lineItems = [
        { type : "line" },     // 直線
        { type : "curve" }     // 曲線
    ]

    private cellStyle(item)
    {
        var index = this.lineItems.indexOf(item);
        var style = "position : absolute;"
        var left = 124 + 184 * index;
        var top = 24;
        style += "left : " + left + "px;";
        style += "top : " + top + "px;";
        style += "padding-bottom : 24px;" 
        return style;
    }

    private isSelected(item)
    {
        var index = this.lineItems.indexOf(item);
        return index == this.selectedIndex;
    }

    private onSelect(item)
    {
        var index = this.lineItems.indexOf(item);
        // 選択状態を変更
        this.selectedIndex = index;
    }

    private onOk()
    {
        var selectedItem = this.lineItems[this.selectedIndex];
        // 選択状態を通知
        this.$emit("select", selectedItem.type);
        // 閉じる
        this.$emit("close");
    }
}
